<template>
	<v-container
		fill-height
		class="cyborg"
	>
		<v-row
			justify="center"
			no-gutters
		>
			<v-col
				xs="12"
				sm="8"
				md="6"
				lg="4"
			>
				<div class="techbox centered">
					<div
						class="techbox-title"
						style="font-size:5rem;padding-bottom:0px;"
					>
						AMOS
						<hr />
						<div class="techbox-subtitle">asset management operating system</div>
					</div>
					<hr />
					<v-container>
						<v-row justify="center">
							<v-col
								xs="10"
								lg="8"
							>
								<v-form
									v-model="loginValidated"
									lazy-validation
									ref="loginform"
								>
									<v-text-field
										v-show="!detecteduser"
										prepend-icon="fa-user"
										ref="username"
										v-model="username"
										label="User Name"
										class="bluehalo"
										:rules="nameRules"
										dark
										color="rgb(0, 255, 255)"
										type="text"
										@keyup.enter="tryLogin"
									></v-text-field>
									<div v-show="detecteduser">{{greetings}}<br />Please Enter your Password</div>
									<v-text-field
										id="password"
										prepend-icon="fa-lock"
										ref="password"
										:rules="pwdRules"
										v-model="password"
										:autofocus="detecteduser!==''"
										label="Password"
										dark
										color="rgb(0, 255, 255)"
										type="password"
										@keyup.enter="tryLogin"
									></v-text-field>
								</v-form>
								<v-spacer></v-spacer>
								<transition name="fade-transition">
									<button
										v-show="ready && loginValidated"
										type="button"
										class="tech-button"
										style="width:100%;"
										@click="tryLogin"
									>Login</button>
								</transition>
								<transition name="fade-transition">
									<button
										v-show="detecteduser"
										type="button"
										class="tech-button"
										style="width:100%;"
										@click="resetCurrentUser"
									>Not Me!</button>
								</transition>
								<button
									type="button"
									class="tech-button"
									style="width:100%;"
									@click="resetDB"
								>RESET DATA</button>

							</v-col>
						</v-row>
					</v-container>

				</div>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import moment from "moment";
export default {
	data() {
		return {
			nameRules: [
				v => !!v || "Username is required!",
				v =>
					(v && v.length > 1) ||
					"Username must be more than 1 characters"
			],
			pwdRules: [
				v => !!v || "Password is required",
				v =>
					(v && v.length > 1) ||
					"Password must be more than 1 characters"
			],
			ready: false,
			loginValidated: false,
			detecteduser: "",
			username: "",
			password: ""
		};
	},
	created() {
		let username = localStorage.username;
		if (username) {
			console.warn("Detected user:", username);
			this.detecteduser = username;
			this.username = username;
		}
		this.loginValidated = false;
	},
	mounted() {
		this.$nextTick(() => {
			this.loginValidated = false;
			this.ready = true;

			console.warn("REFS:", this.$refs);
			if (this.detecteduser) {
				setTimeout(this.$refs.password.focus, 100);
			} else {
				setTimeout(this.$refs.username.focus, 100);
			}
			//setTimeout(this.$refs.password.focus, 100);
		});
	},

	computed: {
		greetings() {
			let m = moment();
			var g = null; //return g

			if (!m || !m.isValid()) {
				return;
			} //if we can't find a valid or filled moment, we return.

			var split_afternoon = 12; //24hr time to split the afternoon
			var split_evening = 17; //24hr time to split the evening
			var currentHour = parseFloat(m.format("HH"));

			if (
				currentHour >= split_afternoon &&
				currentHour <= split_evening
			) {
				g = "Afternoon";
			} else if (currentHour >= split_evening) {
				g = "Evening";
			} else {
				g = "Morning";
			}
			let username = this.detecteduser;

			g = "Good " + g + ", " + username;
			return g;
		}
	},
	methods: {
		resetCurrentUser() {
			this.username = "";
			this.detecteduser = "";
			// localStorage.username = "";
			localStorage.removeItem("username");
			setTimeout(this.$refs.username.focus, 100);
		},
		reset() {
			this.password = "";
			this.username = this.detecteduser !== "" ? this.detecteduser : "";
			this.loginValidated = false;
		},
		// Experimental - just for debugging:
		resetDB() {
			const I = this;
			I.$pouch
				.destroy()
				.then(response => {
					// success
					console.info("DB CLEARED", response);
					location.reload();
					// I.$pouch
					// 	.connect()
					// 	.then(r => {
					// 		console.warn("RECONNECTED", r);
					// 	})
					// 	.catch(e => {
					// 		console.error("[DBCONNECT] ");
					// 	});
				})
				.catch(err => {
					console.error("[DBCLEAR] ", err);
				});
		},
		tryLogin() {
			const I = this;
			//console.warn("Password:", this.password);
			// TEMPORARY!!
			// @todo
			// if (this.password === "helloamos!") {
			if (this.password === "amos") {
				// CHECK IF HAVENT LOGGED IN BEFORE - i.e. no guest user
				this.$pouch
					.get("guest", {})
					.then(doc => {
						console.warn("Guest was found:", doc);
						// I.$store.commit("logIn", { username: doc.username });
						I.$store.dispatch("logIn", {
							pouch: I.$pouch,
							username: doc.username
						});
						this.reset();
					})
					.catch(e => {
						console.warn(
							"Guest was NOT found - installing template!"
						);
						I.$store.dispatch("installTemplate", {
							pouch: I.$pouch
						});
						I.$store.dispatch("logIn", {
							pouch: I.$pouch,
							username: I.username
						});
						this.reset();
					});
			} else {
				alert("Invalid password - please try again!");
			}
		}
	}
};
</script>
